module.exports = __webpack_public_path__ + "img/sample.db174b3d.jpg";